<div *ngIf="isEmpty" class="alert alert-info"> No items found</div>
